module.exports = __webpack_public_path__ + "img/20200312104115289.8c0621c9.jpg";